import * as types from '~/store/mutation-types'
import { guid } from '@/plugins/helper'

export const state = () => ({
  errorMessageArray: []
})

export const getters = {
  errorMessages: state => state.errorMessageArray
}

export const actions = {
  addErrorMessageToQueue({ commit }, error) {
    const payload = {
      ...error,
      id: guid()
    }
    commit(types.ADD_ERROR_MESSAGE_TO_QUEUE, payload)
  },
  removeErrorMessage({ commit }, errorId) {
    commit(types.REMOVE_ERROR_MESSAGE_FROM_QUEUE, errorId)
  },
  clearErrorMessages({ commit }) {
    commit(types.CLEAR_ERROR_MESSAGE_QUEUE)
  }
}

export const mutations = {
  [types.ADD_ERROR_MESSAGE_TO_QUEUE](state, error) {
    state.errorMessageArray = [...state.errorMessageArray, error]
  },
  [types.REMOVE_ERROR_MESSAGE_FROM_QUEUE](state, errorId) {
    state.errorMessageArray = state.errorMessageArray.filter(
      ({ id }) => errorId !== id
    )
  },
  [types.CLEAR_ERROR_MESSAGE_QUEUE](state) {
    state.errorMessageArray = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
